import { ctaBannerFragment } from 'humanity/sections/ctaBanner/ctaBanner.fragment';
import { lcRelatedArticlesFragment } from 'humanity/sections/lcRelatedArticles';
import { simpleRichTextSectionFragment } from 'humanity/sections/simpleRichTextSection/simpleRichTextSection.fragment';

/**
 * @type {String}
 */
export const retirementGlossaryTermFragment = `
  ... on PageContentRetirementGlossaryTerm {
    sys {
      id
    }
    internalTitle
    title
    sectionsCollection(limit: 20) {
      items {
        __typename
        ${simpleRichTextSectionFragment}
        ${ctaBannerFragment}
        ${lcRelatedArticlesFragment}
      }
    }
  }`;
